import queryString from 'query-string';

export const useGetParams = <T extends Record<string, unknown>>() => {
  const search = window.location.search;

  const params = search ? queryString.parse(search) : {};

  return params as T;
};
